import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/settings/company_settings/Page";
import { Page as Error403Component } from "~/containers/specifics/403/Page";
import useItandiAccount from "~/hooks/useItandiAccount";

export const PATH = "/settings/company_settings";

function Home() {
	const { data: session } = useItandiAccount().currentAccount();

	if (session === null) {
		return <Error403Component />;
	}

	return (
		<>
			<NskHead title="会社情報設定" />
			<Component session={session} />
		</>
	);
}

export default Home;
